import { ADD_SERVICE, SAVING_SERVICES, SAVED_SERVICES } from "../actions/dataForState/addServiceAdmin";
import { SET_SERVICES_ADMIN } from "../actions/dataForState/setServicesAdminToState";
import { REMOVE_SERVICE } from "../actions/dataForState/removeServiceAdmin";


export const servicesAdmin = (state = {}, action) => {
    switch(action.type) {
        case SET_SERVICES_ADMIN: {
            return action.payload;
        }
        case ADD_SERVICE: {
            const servicesAdmin = action.payload;
            return servicesAdmin;
        }
        case REMOVE_SERVICE: {
            const servicesAdmin = action.payload;
            return servicesAdmin;
        }
        default:
            return state;
    }
}

export const isSavingServices = (state = {}, action) => {
    switch(action.type) {
        case SAVING_SERVICES: {
            return action.payload;
        }
        default:
            return state;
    }
}

export const isSavedServices = (state = {}, action) => {
    switch(action.type) {
        case SAVED_SERVICES: {
            return action.payload;
        }
        default:
            return state;
    }
}